import { render } from "./studioRoomDetail.vue?vue&type=template&id=1106d27c&scoped=true"
import script from "./studioRoomDetail.vue?vue&type=script&lang=js"
export * from "./studioRoomDetail.vue?vue&type=script&lang=js"

import "./studioRoomDetail.vue?vue&type=style&index=0&id=1106d27c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1106d27c"]])

export default __exports__